import { updateChatbotState } from "./Utils";
import ValidarAdeudos from "../actions/ValidarAdeudos";
import {API_BASE} from "../../../services/apirest";

export const manejarValidacion = async (
    newMessage,
    metodo,
    validacionState,      // 3️⃣ tu state local de validación
    setValidacionState,   // 4️⃣ su setter
    setChatbotState,      // 5️⃣ setter del chatbot
    createChatBotMessage  // 6️⃣ fábrica de mensajes
) => {
    // --- 1) Manejo de respuesta INE ---
    if (validacionState.modoEsperandoINE) {
        const cred = newMessage.trim();
        const nombreCompleto = validacionState.nombreBuscado;
        const url =
            `${API_BASE}/backend/clientes.php` +
            `?nombre_cuenta=${encodeURIComponent(nombreCompleto)}` +
            `&credencial_elector=${encodeURIComponent(cred)}`;

        // Limpiamos flags de validación
        setValidacionState(prev => ({
            ...prev,
            modoEsperandoINE: false,
            nombreBuscado: "",
            posiblesClientes: []
        }));

        try {
            const resp = await fetch(url);
            const { result } = await resp.json();
            const clientes = result.cliente
                ? [result.cliente]
                : Array.isArray(result.clientes)
                    ? result.clientes
                    : [];

            if (!clientes.length) {
                updateChatbotState(
                    setChatbotState,
                    createChatBotMessage("🚫 Clave INE incorrecta o cliente no registrado.")
                );
                return;
            }

            const validacion = new ValidarAdeudos(clientes[0]);
            updateChatbotState(
                setChatbotState,
                createChatBotMessage(validacion.validarAdeudos(), { widget: "opcionesInicio" })
            );
        } catch (err) {
            updateChatbotState(
                setChatbotState,
                createChatBotMessage(`🚨 Error al validar INE: ${err.message}`)
            );
        }

        return;
    }

    // --- 2) Construcción normal de URL ---
    let url = `${API_BASE}/clientes.php?`;

    if (metodo === "telefono") {
        const [dato] = newMessage.split(",").map(p => p.trim());
        if (!dato) {
            updateChatbotState(
                setChatbotState,
                createChatBotMessage("Formato incorrecto. Usa Teléfono (10 dígitos)")
            );
            return;
        }
        url += `telefono=${encodeURIComponent(dato)}`;

    } else if (metodo === "email") {
        const [dato] = newMessage.split(",").map(p => p.trim());
        if (!dato) {
            updateChatbotState(
                setChatbotState,
                createChatBotMessage("Formato incorrecto. Usa Email")
            );
            return;
        }
        url += `email=${encodeURIComponent(dato)}`;

    } else if (metodo === "nombre_cuenta") {
        const parts = newMessage.split(",").map(p => p.trim());
        if (parts.length < 3) {
            updateChatbotState(
                setChatbotState,
                createChatBotMessage("Formato incorrecto. Usa Nombre(s), apellido paterno, apellido materno")
            );
            return;
        }
        const [nombre, paterno, materno] = parts;
        const nombreCompleto = `${nombre} ${paterno} ${materno}`;

        // Guardamos para posible reintento con INE
        setValidacionState(prev => ({
            ...prev,
            nombreBuscado: nombreCompleto
        }));

        url += `nombre_cuenta=${encodeURIComponent(nombreCompleto)}`;

    } else if (metodo === "direccion") {
        const parts = newMessage.split(",").map(p => p.trim());
        if (parts.length < 4) {
            updateChatbotState(
                setChatbotState,
                createChatBotMessage("Formato incorrecto. Usa Calle,Numero,Colonia,Ciudad.")
            );
            return;
        }
        const [calle, numero, colonia, ciudad] = parts;
        url +=
            `nombre_calle=${encodeURIComponent(calle)}` +
            `&numero_exterior=${encodeURIComponent(numero)}` +
            `&colonia=${encodeURIComponent(colonia)}` +
            `&ciudad=${encodeURIComponent(ciudad)}`;
    }

    // --- 3) Fetch y procesado ---
    try {
        const resp = await fetch(url);
        const { result } = await resp.json();
        let clientes = [];
        if (Array.isArray(result)) {
            clientes = result;
        } else if (Array.isArray(result.clientes)) {
            clientes = result.clientes;
        } else if (result.cliente) {
            clientes = [result.cliente];
        }

        if (!clientes.length) {
            updateChatbotState(
                setChatbotState,
                createChatBotMessage("✅ El cliente no se encuentra registrado.", { widget: "opcionesInicio" })
            );
            return;
        }

        if (clientes.length === 1) {
            const validacion = new ValidarAdeudos(clientes[0]);
            updateChatbotState(
                setChatbotState,
                createChatBotMessage(validacion.validarAdeudos(), { widget: "opcionesInicio" })
            );

        } else if (metodo === "direccion" && clientes.length > 1) {
            let msg = `🔎 Se encontraron ${clientes.length} coincidencias:\n\n`;
            clientes.forEach((c, i) => {
                msg += `Cliente ${i+1}:\n${new ValidarAdeudos(c).validarAdeudos()}\n\n`;
            });
            updateChatbotState(
                setChatbotState,
                createChatBotMessage(msg, { widget: "opcionesInicio" })
            );

        } else {
            // Homónimos por nombre_cuenta
            updateChatbotState(
                setChatbotState,
                createChatBotMessage(
                    `🔎 Se encontraron ${clientes.length} homónimos. Por favor, introduce la clave de elector de su INE:`
                )
            );
            setValidacionState(prev => ({
                ...prev,
                posiblesClientes: clientes,
                modoEsperandoINE: true
            }));
        }

    } catch (err) {
        updateChatbotState(
            setChatbotState,
            createChatBotMessage(`🚨 Error en validación: ${err.message}`)
        );
    }
};